import { SliderStoreFactory } from './chunk-53B74NMI.js';
import { Thumbnail } from './chunk-AXU3DGMX.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_walker, $$_effect, $$_attr, $$_setup_custom_element, $$_create_template } from 'maverick.js/dom';
import { useStore } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><media-thumbnail part="thumbnail" mk-d></media-thumbnail>`);
var SliderThumbnail = class extends Component {
  constructor(instance) {
    super(instance);
    this.a = useMedia();
    this.H = useStore(SliderStoreFactory);
  }
  yc() {
    const { duration } = this.a.$store;
    return this.H.pointerRate() * duration();
  }
  render() {
    const time = this.yc.bind(this);
    return (() => {
      const [$$_root, $$_walker] = $$_create_walker($$_templ);
      $$_effect(() => $$_attr($$_root, "time", time()));
      $$_setup_custom_element($$_root);
      return $$_root;
    })();
  }
};
SliderThumbnail.el = defineElement({
  tagName: "media-slider-thumbnail"
});
SliderThumbnail.register = [Thumbnail];

export { SliderThumbnail };
